import React from 'react'
import { Tooltip } from 'antd'
import { AddButton, BodyBox, Box, BoxContainer, PencilButton, TitleBox } from './styles'
import PropTypes from 'prop-types'
export const SectionProfile = (props) => {
  return (
    <BoxContainer>
      <Box>
        <Tooltip title={props.tooltip}>
          <TitleBox>{props.title}</TitleBox>
        </Tooltip>
        {props.pencil === 'true' ? (
          <PencilButton data-testid={`${props.title}-pencil`} size='25' onClick={props.ClickButton} />
        ) : (
          <AddButton data-testid={`${props.title}-plus`} size='25' onClick={props.ClickButton} />
        )}
      </Box>
      <BodyBox>{props.children}</BodyBox>
    </BoxContainer>
  )
}

SectionProfile.propTypes = {
  ClickButton: PropTypes.func,
  children: PropTypes.node,
  pencil: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.string
}
